<template>
  <div>
    <Alert type="warning" style="width: 712px;padding-right: 16px;font-size:12px">
      提示：以下页数按单面计算，双面将自动2倍；此方案适用于将A3和双色独立出来收费的模式，填写指引参照"区间收费"
    </Alert>
    <Form ref="formInline" :model="itemData" :rules="rule" :label-width="110" inline>
      <FormItem prop="name" label="方案名称:">
        <Input v-model="data.name"/>
      </FormItem>
      <FormItem prop="basics" label="基础金额:">
        <InputNumber style="width:141px" :active-change="false" :precision="2" :min="0" :step="1" v-model="data.basics"/>
      </FormItem>
      <FormItem label="结算方案描述">
        <Input style="width: 141px" v-model="data.describe"/>
      </FormItem>
      <br/>
      <FormItem label="免费A4黑白(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.blackA4Num"/>
      </FormItem>
      <FormItem label="免费A4彩色(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.colorA4Num"/>
      </FormItem>
      <FormItem label="免费A3黑白(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.blackA3Num"/>
      </FormItem>
      <FormItem label="免费A3彩色(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.colorA3Num"/>
      </FormItem>
      <FormItem label="免费双色(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.bothNum"/>
      </FormItem>
      <br/>
      <FormItem label="A4黑白:">
        <div class="type5_row">
          区间1:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.black.a4.a.f"/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','a4','a')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.a4.a.t" @on-blur="formatContent()" v-if="itemData.black.a4.a.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.a4.a.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','a4','a')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.black.a4.a.money"/>
        </div>
        <div class="type5_row">
          区间2:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.black.a4.b.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','a4','b')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.a4.b.t" @on-blur="formatContent()" v-if="itemData.black.a4.b.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.a4.b.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','a4','b')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.black.a4.b.money"/>
        </div>
        <div class="type5_row">
          区间3:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.black.a4.c.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','a4','c')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.a4.c.t" @on-blur="formatContent()" v-if="itemData.black.a4.c.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.a4.c.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','a4','c')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.black.a4.c.money"/>
        </div>
      </FormItem>
      <FormItem label="A4彩色:">
        <div class="type5_row">
          区间1:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.color.a4.a.f"/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','a4','a')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.color.a4.a.t" @on-blur="formatContent()" v-if="itemData.color.a4.a.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.a4.a.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','a4','a')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.color.a4.a.money"/>
        </div>
        <div class="type5_row">
          区间2:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.color.a4.b.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','a4','b')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.color.a4.b.t" @on-blur="formatContent()" v-if="itemData.color.a4.b.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.a4.b.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','a4','b')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.color.a4.b.money"/>
        </div>
        <div class="type5_row">
          区间3:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.color.a4.c.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','a4','c')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.color.a4.c.t" @on-blur="formatContent()" v-if="itemData.color.a4.c.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.a4.c.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','a4','c')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.color.a4.c.money"/>
        </div>
      </FormItem>
      <br/>
      <FormItem label="A3黑白:">
        <div class="type5_row">
          区间1:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.black.a3.a.f"/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','a3','a')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.a3.a.t" @on-blur="formatContent()" v-if="itemData.black.a3.a.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.a3.a.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','a3','a')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.black.a3.a.money"/>
        </div>
        <div class="type5_row">
          区间2:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.black.a3.b.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','a3','b')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.a3.b.t" @on-blur="formatContent()" v-if="itemData.black.a3.b.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.a3.b.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','a3','b')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.black.a3.b.money"/>
        </div>
        <div class="type5_row">
          区间3:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.black.a3.c.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('black','a3','c')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.black.a3.c.t" @on-blur="formatContent()" v-if="itemData.black.a3.c.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.black.a3.c.t === -1" value="截至印章" @on-blur="formatEnd($event,'black','a3','c')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.black.a3.c.money"/>
        </div>
      </FormItem>
      <FormItem label="A3彩色:">
        <div class="type5_row">
          区间1:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.color.a3.a.f"/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','a3','a')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.color.a3.a.t" @on-blur="formatContent()" v-if="itemData.color.a3.a.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.a3.a.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','a3','a')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.color.a3.a.money"/>
        </div>
        <div class="type5_row">
          区间2:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.color.a3.b.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','a3','b')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.color.a3.b.t" @on-blur="formatContent()" v-if="itemData.color.a3.b.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.a3.b.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','a3','b')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.color.a3.b.money"/>
        </div>
        <div class="type5_row">
          区间3:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.color.a3.c.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('color','a3','c')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.color.a3.c.t" @on-blur="formatContent()" v-if="itemData.color.a3.c.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.color.a3.c.t === -1" value="截至印章" @on-blur="formatEnd($event,'color','a3','c')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.color.a3.c.money"/>
        </div>
      </FormItem>
      <br/>
      <FormItem label="双色:">
        <div class="type5_row">
          区间1:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.both.a.f"/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('both','a')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.both.a.t" @on-blur="formatContent()" v-if="itemData.both.a.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.both.a.t === -1" value="截至印章" @on-blur="formatEnd($event,'both','a')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.both.a.money"/>
        </div>
        <div class="type5_row">
          区间2:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.both.b.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('both','b')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.both.b.t" @on-blur="formatContent()" v-if="itemData.both.b.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.both.b.t === -1" value="截至印章" @on-blur="formatEnd($event,'both','b')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.both.b.money"/>
        </div>
        <div class="type5_row">
          区间3:
          <InputNumber class="input" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.both.c.f" disabled/>
          至
          <Poptip trigger="hover" placement="right">
            <div style="text-align:center" slot="content">
              <Button type="info" size="small" @click="setEnd('both','c')">截至印张</Button>
            </div>
            <InputNumber class="input" :min="0" :precision="0" v-model="itemData.both.c.t" @on-blur="formatContent()" v-if="itemData.both.c.t !== -1"/>
          </Poptip>

          <Input class="input" v-if="itemData.both.c.t === -1" value="截至印章" @on-blur="formatEnd($event,'both','c')"/>
          单价 (元/页):
          <InputNumber class="input" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.both.c.money"/>
        </div>
      </FormItem>
      <br/>
      <FormItem>
        <Button type="success" @click="save" v-preventReClick :loading="loading">保存</Button>
      </FormItem>
    </Form>
    <!-- <div class="formula-box">
      <div class="row">A4黑白印张 = 黑白总计数 - 2 * A3黑白印张</div>
      <div class="row">A4彩色印张 = 彩色总计数 - 双色 - 2 * A3彩色印张</div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'type5',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      rule: {
        name: [{ validator: (rule, value, cb) => {
          if (!this.data.name) {
            cb(new Error('方案名称未填'))
          } else {
            cb()
          }
        },
        required: true,
        trigger: 'blur' }],
        basics: [{ validator: (rule, value, cb) => {
          if (this.data.basics >= 0) {
            cb()
          } else {
            cb(new Error('基础金额未填'))
          }
        },
        required: true,
        trigger: 'blur' }]
      },
      itemData: {
        blackA4Num: null,
        blackA3Num: null,
        colorA4Num: null,
        colorA3Num: null,
        bothNum: null,
        black: {
          a4: {
            a: { f: null, t: -1, money: null },
            b: { f: null, t: null, money: null },
            c: { f: null, t: null, money: null }
          },
          a3: {
            a: { f: null, t: -1, money: null },
            b: { f: null, t: null, money: null },
            c: { f: null, t: null, money: null }
          }
        },
        color: {
          a4: {
            a: { f: null, t: -1, money: null },
            b: { f: null, t: null, money: null },
            c: { f: null, t: null, money: null }
          },
          a3: {
            a: { f: null, t: -1, money: null },
            b: { f: null, t: null, money: null },
            c: { f: null, t: null, money: null }
          }
        },
        both: {
          a: { f: null, t: -1, money: null },
          b: { f: null, t: null, money: null },
          c: { f: null, t: null, money: null }
        }
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    save () {
      this.$refs.formInline.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.data.agent_id = this.user.id
          this.data.content = JSON.stringify(this.itemData)
          this.data.type = '5'
          this.SaveMeterCharge(this.data).then(res => {
            if (res) {
              this.data.id = res
              this.$Message.success('保存成功')
            }
            this.loading = false
          })
        }
      })
    },
    initData () {
      if (this.data.id && this.data.type == 5) {
        this.itemData = JSON.parse(this.data.content)
      }
    },
    formatContent () {
      // if(this.itemData.blackA4Num){
      //   this.itemData.black.a4.a.f = this.itemData.blackA4Num + 1;
      // }
      // if(this.itemData.blackA3Num){
      //   this.itemData.black.a3.a.f = this.itemData.blackA3Num + 1;
      // }
      // if(this.itemData.colorA4Num){
      //   this.itemData.color.a4.a.f = this.itemData.colorA4Num + 1;
      // }
      // if(this.itemData.colorA3Num){
      //   this.itemData.color.a3.a.f = this.itemData.colorA3Num + 1;
      // }
      // if(this.itemData.bothNum){
      //   this.itemData.both.a.f = this.itemData.bothNum + 1;
      // }
      let types = ['black', 'color', 'both'],
        sizes = ['a3', 'a4'],
        rows = ['a', 'b', 'c']
      types.map(type => {
        rows.map((row, index) => {
          if (type === 'both') {
            if (this.itemData[type][row].t > 0) {
              if (index !== 2) {
                this.itemData[type][rows[index + 1]].f = this.itemData[type][row].t + 1
              }
            } else {
              if (index !== 2) {
                this.itemData[type][rows[index + 1]].f = null
              }
            }
            if (this.itemData[type][row].t <= this.itemData[type][row].f && this.itemData[type][row].t !== -1) {
              this.itemData[type][row].t = null
              if (index !== 2) {
                this.itemData[type][rows[index + 1]].f = null
                this.itemData[type][rows[index + 1]].t = null
              }
            } else if (this.itemData[type][row].t === -1) {
              if (index !== 2) {
                this.itemData[type][rows[index + 1]].f = null
                this.itemData[type][rows[index + 1]].t = null
              }
            }
          } else {
            sizes.map(size => {
              if (this.itemData[type][size][row].t > 0) {
                if (index !== 2) {
                  this.itemData[type][size][rows[index + 1]].f = this.itemData[type][size][row].t + 1
                }
              } else {
                if (index !== 2) {
                  this.itemData[type][size][rows[index + 1]].f = null
                }
              }
              if (this.itemData[type][size][row].t <= this.itemData[type][size][row].f && this.itemData[type][size][row].t !== -1) {
                this.itemData[type][size][row].t = null
                if (index !== 2) {
                  this.itemData[type][size][rows[index + 1]].f = null
                  this.itemData[type][size][rows[index + 1]].t = null
                }
              } else if (this.itemData[type][size][row].t === -1) {
                if (index !== 2) {
                  this.itemData[type][size][rows[index + 1]].f = null
                  this.itemData[type][size][rows[index + 1]].t = null
                }
              }
            })
          }
        })
      })
    },
    setEnd (type, size, row) {
      if (type === 'both') {
        this.itemData[type][size].t = -1
      } else {
        this.itemData[type][size][row].t = -1
      }
      this.formatContent()
    },
    formatEnd (e, type, size, row) {
      if (e.target.value !== '截至印章') {
        if (isNaN(parseInt(e.target.value))) {
          if (type === 'both') {
            this.itemData[type][size].t = null
          } else {
            this.itemData[type][size][row].t = null
          }
        } else {
          if (type === 'both') {
            this.itemData[type][size].t = parseInt(e.target.value)
          } else {
            this.itemData[type][size][row].t = parseInt(e.target.value)
          }
        }
      }
      this.formatContent()
    },
    ...mapActions(['SaveMeterCharge'])
  },
  computed: mapGetters({
    user: 'agent'
  })
}
</script>

<style lang="less" scoped>
  @import '../index.less';
</style>
